import React from 'react';

export default function QuestionResponseView({ displayContent }) {
  if (!displayContent) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-8 text-center">
        <h1 className="text-xl font-semibold text-gray-900">Thank you for your response!</h1>
      </div>
    );
  }

  const { heading, body, ctaText, ctaUrl } = displayContent;

  return (
    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
      <h1 className="text-xl font-semibold text-gray-900 mb-3">{heading}</h1>
      {body && <p className="text-gray-600 mb-4">{body}</p>}
      {ctaText && ctaUrl && (
        <a
          href={ctaUrl}
          className="inline-block mt-2 px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors min-h-[44px]"
        >
          {ctaText}
        </a>
      )}
    </div>
  );
}
